import { TypographyProps } from '@mui/material';
import React from 'react';

import { HeadlineLargeStyled } from './styles';

export const HeadlineLarge: React.FC<TypographyProps> = (props) => {
  return (
    <HeadlineLargeStyled variant="h1" {...props}>
      {props.children}
    </HeadlineLargeStyled>
  );
};
